export default __webpack_public_path__ + "static/media/7.27616999.webp";